import {dateDiffInSeconds} from '@gongxigames/framework/slot/utils';
import { PromotionBalanceEntry } from './PromotionBalanceEntry';

export class PromotionBalanceExtractor {
    static extractFromPlayer(player: any): PromotionBalanceEntry[] {
        if (player?.promotion_balance?.length > 0) {
            return player.promotion_balance?.map((entry: any) => {
                return {
                    id: entry.id,
                    type: entry.type,
                    awarded: entry.awarded,
                    remained: entry.remained,
                    bet: entry.bet,
                    expirationTime: entry.expirationTime,
                    completion: entry.completion,
                    collectedWin: entry.collectedWin,
                    status: entry.status,
                    rulesUrl: entry.rulesUrl,
                };
            });
        }

        return [];
    }

    static hasNewPromotion(player: any): boolean {
        const promotionBalance = PromotionBalanceExtractor.extractFromPlayer(player);

        return promotionBalance.length > 0 && promotionBalance[0].status === 'QUEUED';
    }

    static hasUsedPromotion(player: any): boolean {
        const promotionBalance = PromotionBalanceExtractor.extractFromPlayer(player);

        if (promotionBalance.length > 0 && promotionBalance[0].status === 'IN_USE') {
            const balance = promotionBalance[0];
            if (dateDiffInSeconds(Date.now(), new Date(`${balance.expirationTime}Z`).getTime()) < 0) {
                    return false;
            } else {
                    return true;
            }
        }

        return false;
    }
}
